<template>
<nav class="navbar navbar-expand-md bg-dark navbar-dark">
  <div class="container-fluid">
    <a class="navbar-brand" href="#">ivizri.com</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarText">
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <li class="nav-item"><router-link to="/" class="nav-link">Statewide</router-link></li>
        <li class="nav-item"><router-link to="/local/" class="nav-link">Local</router-link></li>
        <li class="nav-item"><router-link to="/about/" class="nav-link">About</router-link></li>
        <div class="vr d-none d-md-block"></div>
        <li class="nav-item"><Timer /></li>
      </ul>
    </div>
  </div>
</nav>
</template>

<script>
import Timer from "./Timer.vue";

export default {
  components: { Timer },
  name: "Navbvar",
  props: {
    msg: String
  }
};
</script>

<style>
nav {
  z-index: 1000;
}

.title {
  margin-top: 0;
  margin-bottom: 0;
  margin-right: 0 !important;
}

.vr {
  border-left: 2px solid rgba(255, 255, 255, 0.55);
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 0.5rem;
  margin-right: 0.5rem
}

.router-link-active {
  color: #ffff !important;
}

</style>